export default __webpack_public_path__ + "static/postgesql-027783e5966871a2e9650192017d4544.svg";